import { useState, useEffect } from 'react'

import { mySalesService } from '../Services/mySalesService'

const INITIAL_STATE = { sales: [], downloads: [], subscriptionSales: [] }

function useAvailableMonths({ enabled = true } = {}) {
  const [data, setData] = useState(INITIAL_STATE)
  const [isLoading, setIsLoading] = useState(enabled)
  const [error, setError] = useState(false)

  useEffect(() => {
    if (!enabled) {
      setIsLoading(false)
      return undefined
    }

    let isMounted = true
    setIsLoading(true)
    setError(false)

    const fetchData = async () => {
      try {
        const response = await mySalesService.getAvailableMonths()
        if (!isMounted) return
        setData({
          sales: response.sales || [],
          downloads: response.downloads || [],
          subscriptionSales: response.subscriptionSales || [],
        })
      } catch {
        if (isMounted) {
          setData(INITIAL_STATE)
          setError(true)
        }
      } finally {
        if (isMounted) setIsLoading(false)
      }
    }

    fetchData()

    return () => { isMounted = false }
  }, [enabled])

  return { ...data, isLoading, error }
}

export default useAvailableMonths
